import { Injectable } from '@angular/core';
import { DataCoreService, DlistDto, GetDlist_Request, GetDlist_Response} from '@dabnet-kamu/libs/ui';
import { BehaviorSubject, catchError, finalize, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '@dabnet-kamu/libs/ui';
@Injectable({
  providedIn: 'root'
})
export class TebGelirService {
  public period!: number;
  public isReadOnly!: boolean;
  public isBindCheck!: boolean;
  public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
    public gridControlsList$ = this._gridControlsList.asObservable();
     constructor(private dataCoreService: DataCoreService,private _httpClient:HttpClient) {}


  setParams(period: number, isReadOnly:boolean, isBindCheck:boolean){
    this.period = period;
    this.isReadOnly = isReadOnly;
    this.isBindCheck = isBindCheck;
  }

  getData(code: string,control:any, period: number, baseEntity?: string, isSetData?: boolean) {
     let dataSource: any;
     let tableName = "";
    const filterArr = [];
      if (this.isBindCheck && this.isReadOnly){
      tableName = control.showEntity?control.showEntity:control.dlistMetadata.baseEntity;
      dataSource = this.dataCoreService.getOData(tableName);
    dataSource.select(['Kod', 'Ad', 'Donem', 'EkoGelirKod']);
    } 
    else{
      dataSource = this.dataCoreService.getOData(baseEntity);
    dataSource.select(['Kod', 'Ad', 'Donem', 'EkoGelirKod']);
    if (period) filterArr.push(['Donem', '=', period]);
    }
    if (code) filterArr.push(['EkoGelirKod', '=', code]);
    filterArr.push(['EkoGelirKod.Length', '>=', 6]);
    dataSource.filter(filterArr);
    return dataSource;
  }
}
